import React, { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt, faEnvelope, faMapMarkerAlt, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import emailjs from 'emailjs-com';

const Contact = () => {

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_b9u97jx', 'template_qfrdxsn', form.current, 'user_TD8hTmf5BKxqEclGmASNN')
            .then((result) => {
                alert('Your Message Send Successfully.')
            }, (error) => {
                console.log(error.text);
            });
    };

    const phone = <FontAwesomeIcon icon={faMobileAlt} />
    const mail = <FontAwesomeIcon icon={faEnvelope} />
    const address = <FontAwesomeIcon icon={faMapMarkerAlt} />
    const sendMessage = <FontAwesomeIcon icon={faPaperPlane} />

    return (
        <div id="contact" className="container my-5">
            <h2>Contact Me</h2>
            <div className="row align-items-center p-5">
                <div className="col-12 col-md-3 col-lg-3  text-start">
                    <div className="container overflow-hidden">
                        <div className="row gy-4">
                            <div className="col-12">
                                <div className="d-flex align-items-center">
                                    <h3 className="px-4 py-3 bg-btn rounded-circle me-3 text-start">{phone}</h3>
                                    <div>
                                        <h4>Phone Me</h4>
                                        <p>Call: +123 456 789 080</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-flex align-items-center">
                                    <h3 className="px-3 py-3 bg-btn rounded-circle me-3 text-start">{mail}</h3>
                                    <div>
                                        <h4>Email Me</h4>
                                        <p>ihrimon147@gmail.com</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-flex align-items-center">
                                    <h3 className="p-4 py-3 bg-btn rounded-circle me-3 text-start">{address}</h3>
                                    <div>
                                        <h4>Address</h4>
                                        <p>Rangamati, Chittagong.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 col-md-8 col-lg-8">
                    <div className="container overflow-hidden">
                        <form ref={form} onSubmit={sendEmail}>
                            <div className="row text-dark">
                                <div className="col-12 col-md-6 col-lg-6">
                                    <div className="form-floating mb-3">
                                        <input type="text" name="user_name" className="form-control" id="floatingInput" placeholder="Your name" />
                                        <label htmlFor="floatingInput">Your Name</label>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6">
                                    <div className="form-floating mb-3">
                                        <input type="email" name="user_email" className="form-control border-success" id="floatingInput" placeholder="name@example.com" />
                                        <label htmlFor="floatingInput">Email address</label>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6">
                                    <div className="form-floating mb-3">
                                        <input type="tel" className="form-control border-success" id="floatingPassword" placeholder="Mobile number" />
                                        <label htmlFor="floatingPassword">Mobile Number</label>
                                    </div>
                                </div>
                                <div className="col-12 col-md-6 col-lg-6">
                                    <div className="form-floating mb-3">
                                        <input type="text" className="form-control border-success" id="floatingInput" placeholder="name@example.com" />
                                        <label htmlFor="floatingInput">Subject</label>
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-floating">
                                        <textarea type="text" name="message" className="form-control border-success" placeholder="Leave a comment here" id="floatingTextarea2" style={{ height: '100px' }}></textarea>
                                        <label htmlFor="floatingTextarea2">Comments</label>
                                    </div>
                                </div>
                            </div>
                            <button className="btn btn-bg text-light px-4 rounded-pill mt-3">Send Message {sendMessage}</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;